import classNames from 'classnames/bind';
import { DetailedHTMLProps, forwardRef, HTMLAttributes, Ref } from 'react';
import styles from './slider-box.module.scss';

const classesContext = classNames.bind(styles);

function SliderBoxTab(
  {
    children,
    isActive,
    ...restProps
  }: {
    isActive: boolean;
  } & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  ref: Ref<HTMLDivElement>
): JSX.Element {
  return (
    <div
      ref={ref}
      className={classesContext(['tab', { tab__active: isActive }])}
      {...restProps}>
      {children}
    </div>
  );
}

export default forwardRef(SliderBoxTab);
